/*
 * Persisted Actions
 *
 * Stores dispatched actions (with payload) that must be replayed
 * after a context change, like switching the selected shop.
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 19-Jun-2025
 */

import { createAction } from './index'

export const actionTypes = {
  // @generator action:type
  STORE_PERSISTED_ACTION: '@@persisted/store_action',
  CLEAR_PERSISTED_ACTIONS: '@@persisted/clear_all'
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action

/** @action
 * Store an action payload to be re-dispatched after context change
 * @name doStorePersistedAction
 * @param {string} type - The action type to persist (e.g. GET_TRANSACTIONS)
 * @param {object} payload - The original payload for the action
 * @return {object} - The constructed action
 */
export const doStorePersistedAction = (type, payload) => createAction(actionTypes.STORE_PERSISTED_ACTION, { type, payload })

/** @action
 * Clear all previously stored persisted actions
 * @name doClearPersistedActions
 * @return {object} - The constructed action
 */
export const doClearPersistedActions = () => createAction(actionTypes.CLEAR_PERSISTED_ACTIONS)
